import React, { useState, useEffect, useRef, useContext } from 'react';
import axios from '../../../config/axios';

import AuthContext from '../../../contexts/AuthContext';

import Input from '../Input/Input';
import { ReactComponent as ClearIcon } from '../../../svg/cancel.svg';
import { updateObject, checkValidity } from '../../../utilities/utilities';

import classes from './Filter.module.scss';

const Filter = props => {
    const auth = useContext(AuthContext)[0];

    const [state, setState] = useState({
        controls: {
            section: {
                element: 'select',
                dependsOn: null,
                options: [
                    { value: '', displayValue: 'Filter section' },
                ],
                value: '',
                errorMessage: 'Proszę vybrać właściwe',
                ref: useRef()
            },
            participation: {
                element: 'select',
                dependsOn: null,
                options: [
                    { value: '', displayValue: 'Filter participation' }
                ],
                value: '',
                errorMessage: 'Proszę wybrać właściwe',
                ref: useRef()
            },
            role: {
                element: 'select',
                dependsOn: null,
                options: [
                    { value: '', displayValue: 'Filtruj rodzaj udziału' }
                ],
                value: '',
                errorMessage: 'Proszę wybrać właściwe',
                ref: useRef()
            },
            room: {
                element: 'select',
                dependsOn: null,
                options: [
                    { value: '', displayValue: 'Filter conference room' }
                ],
                value: '',
                errorMessage: 'Please, select room',
                ref: useRef()
            }
        }
    })
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        props.changed(props.id, state.controls[props.filter].value)
    }, [state])

    useEffect(() => {
        let axiosAction = null;
        let field = null;

        switch (props.filter) {
            case 'section':
                axiosAction = axios.get(`/sections.json?auth=${auth.token}`);
                field = 'section';
                break;
            case 'participation':
                axiosAction = axios.get(`/participations.json?auth=${auth.token}`);
                field = 'participation';
                break;
            case 'role':
                axiosAction = axios.get(`/organizer-roles.json?auth=${auth.token}`);
                field = 'description';
                break;
            case 'room':
                axiosAction = axios.get(`/rooms.json?auth=${auth.token}`);
                field = 'description';
                break;
            default:
                axiosAction = null;
        }

        Promise.all([axiosAction])
            .then(response => {
                let updatedControls = null;
                const res = response[0].data;

                let loadedObjects = null;
                loadedObjects = Object.keys(res)
                    .map(key => ({
                        value: key,
                        displayValue: res[key][field]
                    }))
                    .sort((el1, el2) => {
                        if (el1.displayValue >= el2.displayValue) {
                            return 1
                        } else {
                            return -1
                        }
                    })

                const currentObjects = state.controls[props.filter].options.concat(loadedObjects);
                updatedControls = {
                    ...state.controls,
                    [props.filter]: {
                        ...state.controls[props.filter],
                        options: currentObjects
                    }
                }

                setState({ controls: updatedControls });
                setLoading(false)
            })
    }, []);

    const inputChangedHandler = (eventType, controlName) => {
        let updatedControls = null;
        updatedControls = updateObject(state.controls, {
            [controlName]: updateObject(state.controls[controlName], {
                value: state.controls[controlName].ref.current.value
            })
        })
        setState({ controls: updatedControls });
    }

    const onFilterClearHandler = (controlName) => {
        let updatedControls = null;
        updatedControls = updateObject(state.controls, {
            [controlName]: updateObject(state.controls[controlName], {
                value: ''
            })
        })
        setState({ controls: updatedControls });
    }

    return <div className={classes.Filter}>
        {state.controls[props.filter].value.length > 0
            ? <div className={classes.ClearIcon}>
                <span onClick={() => onFilterClearHandler(props.filter)}><ClearIcon /></span>
            </div>
            : null
        }
        <div className={state.controls[props.filter].value.length > 0 ? classes.FilterForm : classes.FilterFormWide}>
            {!loading
                ? <Input
                    key={props.filter}
                    id={props.filter}
                    data={state.controls[props.filter]}
                    disabled={false}
                    changed={inputChangedHandler} />
                : null}
        </div>

    </div>
}

export default Filter;